import React from "react";
import { I18n } from "react-redux-i18n";
import styled from "styled-components";
import Modal from "@alboompro/boom-components/data-display/modal";
import Button from "@alboompro/boom-components/general/button";

const ModalContent = styled.div`
  padding: 30px;
  background: #f8f8f8;
  p {
    margin: 0;
    margin-bottom: 20px;
    font-size: 16px;
  }
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DeleteBtn = styled(Button)`
  background-color: #ef5d5d;
  color: white !important;
  margin-left: 15px;
`;

const DeleteModal = ({ isOpen, element, onConfirm, onCancel }) => {
  return (
    <Modal
      title={I18n.t("deleteModal.title", { element })}
      visible={isOpen}
      onClose={onCancel}
      headerStyle={{
        fontWeight: "500",
        textTransform: "uppercase",
        fontFamily: "Poppins, sans-serif"
      }}
      bodyStyle={{
        color: "#363636",
        lineHeight: "1.3",
        fontWeight: "400",
        fontFamily: "Poppins, sans-serif"
      }}
      footer={
        <FooterContent>
          <Button onClick={onCancel}>{I18n.t("general.cancel")}</Button>
          <DeleteBtn textStyle={{ color: "white" }} onClick={onConfirm}>
            {I18n.t("deleteModal.confirm", { element })}
          </DeleteBtn>
        </FooterContent>
      }
    >
      <ModalContent
        dangerouslySetInnerHTML={{
          __html: I18n.t("deleteModal.details", { element })
        }}
      />
    </Modal>
  );
};

export default DeleteModal;
